<body>
	<div id="notfound">
		<div class="notfound">
			<div class="notfound-404">
				<h3>Oops! Failed to load ASP.NET Core runtime</h3>
				<h1>HTTP Error <span>5</span><span>0</span><span>0.31</span></h1>
			</div>
			<h2>we are sorry, but please check prerequisite setups</h2>
		</div>
	</div>

</body>
